import React, { Suspense, useCallback, useEffect, useState } from 'react';
import './App.css';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { dependencies } from '../index';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import Cookies from 'js-cookie';
import axios from 'axios';
import { fetchCountrySortCode, getCountryCodes, getIpLocation } from '../redux/location/locationActions';
import { getSpaceActivities } from './Result/ResultAction';
import * as ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { Helmet } from 'react-helmet';
import 'font-awesome/css/font-awesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import AppRoutes from './AppRoutes';
import { getHomePageData } from './Home/HomeAction';
import { BASE_URL, FACEBOOK_META_TAG } from '../settings';
import { SINGAPORE_URL, SRI_LANKA_URL, AUSTRALIA_URL } from './HostOnBoarding/HostOnboardingConstants';
import { COUNTRY_CODES } from './Common/constants';
import { getUserDetailByToken, updateReduxWithAuthDetails } from '../redux/auth/authAction';


function App() {
  const dispatch = useDispatch();

  const mockFunction = useCallback(() => {
  });
  const [cookies, setCookie] = useCookies(['authDetails']);
  const pathName = useSelector((state) => state?.router?.location?.pathname || {});
  const authDetails = useSelector((state) => state?.auth?.loginDetails?.data?.token || null);
  const coordinates = useSelector((state) => state?.locationMeta?.coordinates || {});
  const countryLongName = useSelector((state) => state?.locationMeta?.data?.country_longCode?.replace(" ", "-") || null);
  const countryShortCode = useSelector(state => state?.locationMeta?.data?.country_shortCode);
  const [setectedCountry, setSelectedCountry] = useState(null)
  const [isCountryFromLocation, setIsCountryFromLocation] = useState(false);
  const [isAuthBootstrapComplete, setIsAuthBootstrapComplete] = useState(false);

  useEffect(() => { 
    if (countryShortCode && countryShortCode !== setectedCountry) {
      dispatch(getHomePageData(countryShortCode));
      dispatch(getSpaceActivities(countryShortCode));
      setSelectedCountry(countryShortCode)
    }
  }, [countryShortCode]);

  useEffect(() => {
    ReactGA.pageview(pathName);
    ReactPixel.pageView();
  }, [pathName]);

  useEffect(() => {
    let isMounted = true;

    const completeBootstrap = () => {
      if (isMounted) {
        setIsAuthBootstrapComplete(true);
      }
    };

    const syncAuthState = (token) => {
      if (!token) {
        return;
      }

      Cookies.set('token', token, {
        expires: 1,
        secure: true,
        sameSite: 'Strict',
        path: '/'
      });

      dispatch(updateReduxWithAuthDetails({ token }));
      dispatch(getUserDetailByToken(token));
    };

    const bootstrapAuth = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = searchParams.get('token');

      if (tokenFromUrl) {
        syncAuthState(tokenFromUrl);
        searchParams.delete('token');

        const nextSearch = searchParams.toString();
        const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash || ''}`;
        window.history.replaceState({}, document.title, nextUrl);
        completeBootstrap();
        return;
      }

      if (Cookies.get('token') || authDetails) {
        completeBootstrap();
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}auth/me`, { withCredentials: true });
        const tokenFromSession = response?.data?.token || response?.data?.accessToken || response?.data;

        if (typeof tokenFromSession === 'string' && tokenFromSession) {
          syncAuthState(tokenFromSession);
        }
      } catch (error) {
        // No active refresh session is a valid unauthenticated state.
      } finally {
        completeBootstrap();
      }
    };

    bootstrapAuth();

    return () => {
      isMounted = false;
    };
  }, [authDetails, dispatch]);

  useEffect(() => {

    if (pathName.includes(SRI_LANKA_URL) || pathName.includes('all')) {
      dispatch(fetchCountrySortCode({ country_longCode: COUNTRY_CODES.SRI_LANKA.country_longCode }));
    } else {
      dispatch(getIpLocation());
      setIsCountryFromLocation(true);
    }
  }, []);

  useEffect(() => {
    if (coordinates?.lat && coordinates?.lng) {
      dispatch(getCountryCodes());
    }
  }, [coordinates]);

  useEffect(() => {
    if (isAuthBootstrapComplete && countryLongName && isCountryFromLocation) {
      window.location.href = '/' + countryLongName;
    }
  }, [countryLongName, isAuthBootstrapComplete, isCountryFromLocation]);

  useEffect(() => {
    if (!Cookies.get('token')) {
      if (authDetails) {
        setCookie('token', authDetails, { path: '/' });
      }
    }
  }, [authDetails]);

  return (
    <div className={`App ms-styles-wrapper ${dependencies.history.location.pathname.includes('/spaces') ? 'space-page' : ''}`}>
      {pathName === '/'+countryLongName &&
      <Helmet>
        <meta name="facebook-domain-verification" content={FACEBOOK_META_TAG} />
      </Helmet>
      }
      <>
        <ErrorBoundary>
          <ConnectedRouter history={dependencies.history}>
            <Suspense fallback={null}>
              <Switch>
                <Route
                    path="/:country"
                    component={AppRoutes}
                 />
              </Switch>

            </Suspense>
          </ConnectedRouter>
        </ErrorBoundary>
      </>
    </div>
  );
}

export default App;
